import React from 'react';

interface Props {
    categories: string[];
    counts: Record<string, number>;
    disabled: string[];
    onToggle: (category: string) => void;
}

const CategoryChips: React.FC<Props> = ({categories, counts, disabled, onToggle}) => (
    <div className="GmChipRow">
        {categories.map(category => (
            <button
                key={category}
                type="button"
                className={`GmChip ${!disabled.includes(category) ? 'GmChip--active' : ''}`}
                onClick={() => onToggle(category)}
            >
                {category}
                <span className="GmChip-count">{counts[category] ?? 0}</span>
            </button>
        ))}
    </div>
);

export default CategoryChips;
